import Login from '@assets/login/login';

export default class extends Login {
  // eslint-disable-next-line no-useless-constructor
  constructor() {
    super();
  }

  init() {
    super.init();
    this.tabs();
    this.appleOuthLogin();
  }

  tabs() {
    $('.nav-tabs').on('click', '.nav-link', (e) => {
      return $(e.currentTarget).attr('aria-controls') === 'register'
        ? $('.card-trackorder, .card-wishlist').removeClass('h-100').addClass('fit-content')
        : $('.card-trackorder, .card-wishlist').addClass('h-100').removeClass('fit-content');
    });
  }

  appleOuthLogin() {
    // Listen for authorization success.
    document.addEventListener('AppleIDSignInOnSuccess', (event) => {
      // Handle successful response.
      const url = $('#appleid-signin').data('redirect');
      const dataToSend = Object.assign(event.detail.authorization, { ajax: true });
      $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: dataToSend,
        success: function (response) {
          window.location.href = response.redirectUrl;
        },
        error: function (err) {
          // Handle Ajax Error
          // eslint-disable-next-line
          console.log('Ajax error: ' + JSON.stringify(err));
        }
      });
    });

    document.addEventListener('AppleIDSignInOnFailure', (event) => {
      // Handle error.
      // eslint-disable-next-line no-console
      console.error(event.detail.error);
    });
  }
}
